import { useState, useEffect } from "react";
import { saveUserAttendance, fetchWorkingDaysData, fetchResourceData } from "../Api/UserAttendance";
import { Container, Form, Button, Row, Col } from "react-bootstrap";

import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
const UserAttendance = () => {
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [workingDaysData, setWorkingDaysData] = useState([]);
  const [resourceData, setResourceData] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    workingDaysId: "",
    resourceId: "",
    salaryDays: ""
  });
  const{user}=useAuth();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [workingDays, resources] = await Promise.all([
          fetchWorkingDaysData(user?.organisationId),
          fetchResourceData(user?.organisationId)
        ]);
        setWorkingDaysData(workingDays);
        setResourceData(resources);
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e) => {
    setAttendanceData({ ...attendanceData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveUserAttendance(attendanceData);
      toast.success("User Attendance Saved Successfully");
      setAttendanceData({
        workingDaysId: "",
        resourceId: "",
        salaryDays: ""
      });
    } catch (error) {
      toast.error("Error Saving Attendance: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">User Attendance Form</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Working Days ID <span className="text-red">**</span></Form.Label>
                    <Form.Select
                      name="workingDaysId"
                      value={attendanceData.workingDaysId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Working Days ID</option>
                      {workingDaysData.map((item) => (
                        <option key={item.workingDaysId} value={item.workingDaysId}>
                          {item.workingMonth}-{item.workingYear}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Resource ID <span className="text-red">**</span></Form.Label>
                    <Form.Select
                      name="resourceId"
                      value={attendanceData.resourceId}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Resource ID</option>
                      {resourceData.map((resource) => (
                        <option key={resource.resourceId} value={resource.resourceId}>
                          {resource.resourceId} - {resource.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Salary Days <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="decimal"
                      name="salaryDays"
                      value={attendanceData.salaryDays}
                      onChange={handleChange}
                      min="0"
                      max="31"
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Attendance
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default UserAttendance;
